import React from "react";
import { Modal, Button } from "react-bootstrap";
import DeleteRedIcon from "../icons/DeleteRedIcon";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { AcceptRequestModalType } from "../constants/utlis";
import { all_routes } from "../feature-module/router/all_routes";
import { useDispatch } from "react-redux";
import { acceptRejectLogHour } from "../core/data/redux/logHour/_logHourAction";
import GreenTickIcon from "../icons/GreenTickIcon";

interface AcceptRequestModalProps {
  show: boolean;
  onHide: () => void;
  type: AcceptRequestModalType;
  uuid?: string | null;
}

const AcceptRequestModal: React.FC<AcceptRequestModalProps> = ({ show, onHide, type, uuid }) => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const routes: any = all_routes;

  const handleConfirmAction = async () => {
    try {
      switch (type) {

        case "acceptRequestByOwner":
          if (!uuid) {
            toast.error("No user selected for archiving");
            return;
          }
          await dispatch(acceptRejectLogHour({ uuid, values: { status: "accept" } }));
          onHide();
          break;

        default:
          break;
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.error);
      }
      console.log(error);
    }
  };

  const getModalContent = () => {
    switch (type) {

      case "acceptRequestByOwner":
        return {
          icon: <GreenTickIcon />,
          title: "Accept Request",
          message: "Are you sure you want to accept this request?",
          confirmText: "Confirm",
          cancelText: "Cancel",
        };


      default:
        return {
          icon: <DeleteRedIcon />,
          title: "Confirmation",
          message: "Are you sure?",
          confirmText: "Yes",
          cancelText: "No",
        };
    }
  };

  const { icon, title, message, confirmText, cancelText } = getModalContent();

  return (
    <Modal
      className="deleteModal"
      show={show}
      onHide={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="text-center">
        <div className="mx-auto py-4">{icon}</div>
        <h4>{title}</h4>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer className="justify-content-center gap-3">
        <Button className="btnWrp cancelBtn" onClick={onHide}>
          {cancelText}
        </Button>
        <Button className="btnWrp" onClick={handleConfirmAction}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AcceptRequestModal;